module.exports = __webpack_public_path__ + "static/media/zosial.e11506ba.jpg";